import ContactForm from "../../components/ContactForm";
import Section from "../../components/Section";
import SectionBox from "../../components/SectionBox";
import SectionLayout from "../../components/[przyjaznedeklaracje]/_sectionLayout";

import DeclarationBox from "../../components/DeclarationBox";
import DeclarationBoxItem from "../../components/DeclarationBoxItem";
import DeclarationModal from "../../components/DeclarationModal";

import Variables from "../../variables/variables.json";

import JakToDzialaSection1PL from "../../content/przyjaznedeklaracje/jak-to-dziala/section-1_pl.mdx";
import JakToDzialaSection2PL from "../../content/przyjaznedeklaracje/jak-to-dziala/section-2_pl.mdx";
import JakToDzialaSection3PL from "../../content/przyjaznedeklaracje/jak-to-dziala/section-3_pl.mdx";
import DeclarationBoxItemMinutes from "../../components/DeclarationBoxItemMinutes";

export default function JakToDziala(props) {
	let Miasto = "PRZYJAZNEDEKLARACJE";
	let Podatek = "jaktodziala";

	return (
		<SectionLayout miasto={Miasto} podatek={Podatek} typeHero="slider" breadcrumbsLayout="light">
			<Section mdx>
				<JakToDzialaSection1PL />
			</Section>

			<Section title="sections.jakkorzystac.title" lightdark>
				<SectionBox light section="jakkorzystac" box center />
			</Section>

			<Section mdx>
				<JakToDzialaSection2PL />
			</Section>

			<Section mdx lightdark>
				<JakToDzialaSection3PL />
			</Section>

			<Section id="wypelnij-deklaracje" title="sections.wypelnijdeklaracje.title">
				<DeclarationBox miasto={Miasto} center>
					{Variables.miasta[Miasto].declarationBoxItem[Podatek].map((declarationBoxItem, index) => {
						return (
							<DeclarationBoxItem
								miasto={Miasto}
								podatek={declarationBoxItem.title}
								key={index}
								soon={declarationBoxItem.soon && true}
							/>
						);
					})}
					<DeclarationBoxItemMinutes />
				</DeclarationBox>
				<DeclarationModal miasto={Miasto} context={Podatek} />
			</Section>
		</SectionLayout>
	);
}
